import { getEspaceDistributeurServicesApi } from '@/core/lib/ApiUtils';
import Cache from '@/core/lib/Cache';
import { getLoggedInUser } from '@/plugins/authentication/lib/Authentication';

export interface ContexteRsiItemApi {
  id: string;
  libelle: string | null;
  club_expert: boolean;
}

export interface SearchContexteRsiApi {
  page: number;
  page_size: number;
  total: number;
  contexte_rsi: ContexteRsiItemApi[];
}

export interface ContexteRsiItem {
  code: string;
  label: string | undefined;
  clubExpert: boolean;
}

export type ContexteRsiSortableKey = keyof Pick<ContexteRsiItem, 'code' | 'label'>;

export function mapContexteRsiItemApiToContexteRsiItem({
  id,
  libelle,
  club_expert,
}: ContexteRsiItemApi): ContexteRsiItem {
  return {
    code: id,
    label: libelle ?? undefined,
    clubExpert: club_expert,
  };
}

export function mapContexteRsiItemToContexteRsiItemApi({
  code,
  label,
  clubExpert,
}: ContexteRsiItem): ContexteRsiItemApi {
  return {
    id: code,
    libelle: label ?? null,
    club_expert: clubExpert,
  };
}

export function assembleContexteRsiCodeLabel({ code, label }: ContexteRsiItem): string {
  return label ? `${code} - ${label}` : code;
}

const cache = new Cache<Promise<ContexteRsiItem[]>>();

export async function getContexteRsi(): Promise<ContexteRsiItem[]> {
  return cache.getOrSet('contexteRsi', () =>
    Promise.all([getLoggedInUser(), getEspaceDistributeurServicesApi()])
      .then(([{ distributeur }, api]) =>
        api.get<SearchContexteRsiApi>(`/distributeurs/${distributeur.id}/contexte-rsi?page=0&page_size=1000`),
      )
      .then(({ data: { contexte_rsi } }) => contexte_rsi.map(mapContexteRsiItemApiToContexteRsiItem)),
  );
}
